import _toConsumableArray from "@babel/runtime/helpers/esm/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { defineStore, storeToRefs } from 'pinia';
import { compareDesc, format, parseISO } from 'date-fns';
import { ru } from 'date-fns/locale';
import { FAMILY_PROFILE_UUID_STORAGE_KEY } from '~/core/constants/sessionStorage';
import useMedcardStore from '~/stores/useMedcardStore';
import { reduceByDate } from '~/features/Medcard/functions';
import { MedcardApi } from '~/features/Medcard/api/medcard.api';
import getDocumentGroupDate from '~/features/Medcard/functions/getDocumentGroupDate';
import { FoldersApi } from '~/features/Medcard/api/folders.api';
import { TreatmentPlanApi } from '~/features/Medcard/api/treatmentPlan.api';
import { UnconfirmedDocumentType } from '~/features/UnconfirmedDocuments/enums';
import { DocumentGroupStatus } from '~/features/Medcard/enums';
export default defineStore('medcardDocuments', function () {
  var medcardStore = useMedcardStore();
  var _storeToRefs = storeToRefs(medcardStore),
    familyProfileUuid = _storeToRefs.familyProfileUuid;
  var _useNuxtApp = useNuxtApp(),
    $captureException = _useNuxtApp.$captureException;
  var totalDocumentsCount = ref(0);
  var documentsCount = ref({});
  var flatMedcardDocuments = ref({});
  var folders = ref([]);
  var externalDocumentGroup = ref(null);
  var unconfirmedDocuments = ref(null);
  var medcardDocumentsCount = computed(function () {
    var _documentsCount$value;
    return familyProfileUuid.value ? (_documentsCount$value = documentsCount.value[familyProfileUuid.value]) !== null && _documentsCount$value !== void 0 ? _documentsCount$value : 0 : 0;
  });
  var medcardFlatDocuments = computed(function () {
    return familyProfileUuid.value ? flatMedcardDocuments.value[familyProfileUuid.value] || [] : [];
  });
  var medcardDocumentGroups = computed(function () {
    return familyProfileUuid.value && flatMedcardDocuments.value[familyProfileUuid.value] ? reduceByDate(flatMedcardDocuments.value[familyProfileUuid.value]) : [];
  });
  function deleteDocumentGroup(id) {
    Object.keys(flatMedcardDocuments.value).forEach(function (uuid) {
      var index = flatMedcardDocuments.value[uuid].findIndex(function (item) {
        return item.id === id;
      });
      flatMedcardDocuments.value[uuid].splice(index, 1);
    });
  }
  function readDocumentGroup(id) {
    Object.keys(flatMedcardDocuments.value).forEach(function (uuid) {
      var documentGroup = flatMedcardDocuments.value[uuid].find(function (item) {
        return item.id === id;
      });
      if (documentGroup) {
        documentGroup.isNew = false;
      }
    });
  }
  function markDocumentGroupAsDeletedByLpu(id) {
    Object.keys(flatMedcardDocuments.value).forEach(function (uuid) {
      var documentGroup = flatMedcardDocuments.value[uuid].find(function (item) {
        return item.id === id;
      });
      if (documentGroup) {
        documentGroup.status = DocumentGroupStatus.DeletedByLpu;
      }
    });
  }
  function fetchMedcardState() {
    return _fetchMedcardState.apply(this, arguments);
  }
  /** Под капотом использует метод fetchMedcardState, не вызывается если документы по выбранному семейнику уже есть */
  function _fetchMedcardState() {
    _fetchMedcardState = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var _yield$MedcardApi$get, data, newDocumentsCount, date;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return MedcardApi.getState();
          case 3:
            _yield$MedcardApi$get = _context.sent;
            data = _yield$MedcardApi$get.data;
            newDocumentsCount = {};
            data.familyProfilesStatistics.forEach(function (_ref2) {
              var familyProfileUuid = _ref2.familyProfileUuid,
                documentGroupsCount = _ref2.documentGroupsCount;
              newDocumentsCount[familyProfileUuid] = documentGroupsCount;
            });
            documentsCount.value = _objectSpread(_objectSpread({}, documentsCount.value), newDocumentsCount);
            totalDocumentsCount.value = data.totalDocumentGroupsCount;
            if (data.externalDocumentGroup !== null) {
              date = getDocumentGroupDate(data.externalDocumentGroup);
              externalDocumentGroup.value = _objectSpread(_objectSpread({}, data.externalDocumentGroup), {}, {
                dateVisit: format(parseISO(date), 'd MMMM yyyy', {
                  locale: ru
                }),
                dateGenerated: parseISO(date),
                isNew: true
              });
            }
            _context.next = 15;
            break;
          case 12:
            _context.prev = 12;
            _context.t0 = _context["catch"](0);
            $captureException(_context.t0, {
              component: 'useMedcardDocumentsStore',
              method: 'fetchMedcardState'
            });
          case 15:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 12]]);
    }));
    return _fetchMedcardState.apply(this, arguments);
  }
  function fetchMedcardDocumentsCount() {
    return _fetchMedcardDocumentsCount.apply(this, arguments);
  }
  function _fetchMedcardDocumentsCount() {
    _fetchMedcardDocumentsCount = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            if (!(!familyProfileUuid.value || documentsCount.value[familyProfileUuid.value] === undefined)) {
              _context2.next = 3;
              break;
            }
            _context2.next = 3;
            return fetchMedcardState();
          case 3:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return _fetchMedcardDocumentsCount.apply(this, arguments);
  }
  function fetchMedcardGroups(_x) {
    return _fetchMedcardGroups.apply(this, arguments);
  }
  function _fetchMedcardGroups() {
    _fetchMedcardGroups = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3(_ref) {
      var _ref$mandatory, mandatory, _ref$withError, withError, uuid, _yield$MedcardApi$get2, data;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _ref$mandatory = _ref.mandatory, mandatory = _ref$mandatory === void 0 ? false : _ref$mandatory, _ref$withError = _ref.withError, withError = _ref$withError === void 0 ? false : _ref$withError;
            uuid = sessionStorage.getItem(FAMILY_PROFILE_UUID_STORAGE_KEY);
            if (!(uuid && flatMedcardDocuments.value[uuid] && !mandatory)) {
              _context3.next = 4;
              break;
            }
            return _context3.abrupt("return");
          case 4:
            _context3.prev = 4;
            _context3.next = 7;
            return MedcardApi.getAll();
          case 7:
            _yield$MedcardApi$get2 = _context3.sent;
            data = _yield$MedcardApi$get2.data;
            if (uuid) {
              flatMedcardDocuments.value = _objectSpread(_objectSpread({}, flatMedcardDocuments.value), {}, _defineProperty({}, uuid, data));
              documentsCount.value = _objectSpread(_objectSpread({}, documentsCount.value), {}, _defineProperty({}, uuid, data.length));
            }
            _context3.next = 17;
            break;
          case 12:
            _context3.prev = 12;
            _context3.t0 = _context3["catch"](4);
            $captureException(_context3.t0, {
              component: 'useMedcardDocumentsStore',
              method: 'fetchMedcardGroups'
            });
            if (!withError) {
              _context3.next = 17;
              break;
            }
            throw _context3.t0;
          case 17:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[4, 12]]);
    }));
    return _fetchMedcardGroups.apply(this, arguments);
  }
  function fetchMedcardFolders() {
    return _fetchMedcardFolders.apply(this, arguments);
  }
  function _fetchMedcardFolders() {
    _fetchMedcardFolders = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
      var _yield$FoldersApi$get, data;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) switch (_context4.prev = _context4.next) {
          case 0:
            _context4.prev = 0;
            _context4.next = 3;
            return FoldersApi.getMedcardFolders();
          case 3:
            _yield$FoldersApi$get = _context4.sent;
            data = _yield$FoldersApi$get.data;
            folders.value = data;
            _context4.next = 11;
            break;
          case 8:
            _context4.prev = 8;
            _context4.t0 = _context4["catch"](0);
            $captureException(_context4.t0, {
              component: 'useMedcardDocumentsStore',
              method: 'fetchMedcardFolders'
            });
          case 11:
          case "end":
            return _context4.stop();
        }
      }, _callee4, null, [[0, 8]]);
    }));
    return _fetchMedcardFolders.apply(this, arguments);
  }
  function fetchUnconfirmedDocuments() {
    return _fetchUnconfirmedDocuments.apply(this, arguments);
  }
  function _fetchUnconfirmedDocuments() {
    _fetchUnconfirmedDocuments = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
      var _yield$Promise$all, _yield$Promise$all2, documentsData, treatmentPlansData;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.prev = 0;
            _context5.next = 3;
            return Promise.all([MedcardApi.getUnconfirmedDocuments(), TreatmentPlanApi.getUnconfirmedTreatmentPlans()]);
          case 3:
            _yield$Promise$all = _context5.sent;
            _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
            documentsData = _yield$Promise$all2[0].data;
            treatmentPlansData = _yield$Promise$all2[1].data;
            unconfirmedDocuments.value = [].concat(_toConsumableArray(documentsData.map(function (item) {
              return _objectSpread({
                type: UnconfirmedDocumentType.Document
              }, item);
            })), _toConsumableArray(treatmentPlansData.map(function (item) {
              return _objectSpread({
                type: UnconfirmedDocumentType.TreatmentPlan
              }, item);
            }))).sort(function (a, b) {
              return compareDesc(new Date(a.dtCreated), new Date(b.dtCreated));
            });
            _context5.next = 14;
            break;
          case 10:
            _context5.prev = 10;
            _context5.t0 = _context5["catch"](0);
            $captureException(_context5.t0, {
              component: 'useMedcardDocumentsStore',
              method: 'fetchUnconfirmedDocuments'
            });
            throw _context5.t0;
          case 14:
          case "end":
            return _context5.stop();
        }
      }, _callee5, null, [[0, 10]]);
    }));
    return _fetchUnconfirmedDocuments.apply(this, arguments);
  }
  return {
    totalDocumentsCount: totalDocumentsCount,
    documentsCount: documentsCount,
    flatMedcardDocuments: flatMedcardDocuments,
    folders: folders,
    externalDocumentGroup: externalDocumentGroup,
    unconfirmedDocuments: unconfirmedDocuments,
    medcardDocumentsCount: medcardDocumentsCount,
    medcardFlatDocuments: medcardFlatDocuments,
    medcardDocumentGroups: medcardDocumentGroups,
    deleteDocumentGroup: deleteDocumentGroup,
    readDocumentGroup: readDocumentGroup,
    fetchMedcardState: fetchMedcardState,
    fetchMedcardDocumentsCount: fetchMedcardDocumentsCount,
    fetchMedcardGroups: fetchMedcardGroups,
    fetchMedcardFolders: fetchMedcardFolders,
    fetchUnconfirmedDocuments: fetchUnconfirmedDocuments,
    markDocumentGroupAsDeletedByLpu: markDocumentGroupAsDeletedByLpu
  };
});